/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CredentialsUpdateResult} from '../models/CredentialsUpdateResult';
import type {CrmAccountSettings} from '../models/CrmAccountSettings';
import type {Error} from '../models/Error';
import type {GetAuthMsDynamicsCredentialsRequest} from '../models/GetAuthMsDynamicsCredentialsRequest';
import type {MsDynamicCredentials} from '../models/MsDynamicCredentials';
import type {SaveAuthMsDynamicsCredentialsRequest} from '../models/SaveAuthMsDynamicsCredentialsRequest';

export interface CheckMsDynamicCredentials$Request {
    accountId: number;
    msDynamicCredentials: MsDynamicCredentials;
}

export interface CheckMsDynamicCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const checkMsDynamicCredentialsRequest = createAction<PayloadData<void, CheckMsDynamicCredentials$Request>>('MS_DYNAMICS_CONTROLLER__CHECK_MS_DYNAMIC_CREDENTIALS__REQUEST');
export const checkMsDynamicCredentialsSuccess = createAction<PayloadData<CredentialsUpdateResult, CheckMsDynamicCredentials$Request>>('MS_DYNAMICS_CONTROLLER__CHECK_MS_DYNAMIC_CREDENTIALS__SUCCESS');
export const checkMsDynamicCredentialsFailure = createAction<PayloadData<Error, CheckMsDynamicCredentials$Request, true>>('MS_DYNAMICS_CONTROLLER__CHECK_MS_DYNAMIC_CREDENTIALS__FAILURE');

export const checkMsDynamicCredentialsActions = [
    checkMsDynamicCredentialsRequest,
    checkMsDynamicCredentialsSuccess,
    checkMsDynamicCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {MsDynamicCredentials} meta.msDynamicCredentials
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const checkMsDynamicCredentials = (meta: CheckMsDynamicCredentials$Request, config?: CheckMsDynamicCredentials$Config) => {
    return {
        CALL_API: {
            types: checkMsDynamicCredentialsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/credentials-check`,
            TRANSPORT_REQUEST_BODY: meta.msDynamicCredentials,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface CleanupMsDynamicOAuthCredentials$Request {
    accountId: number;
}

export interface CleanupMsDynamicOAuthCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const cleanupMsDynamicOAuthCredentialsRequest = createAction<PayloadData<void, CleanupMsDynamicOAuthCredentials$Request>>('MS_DYNAMICS_CONTROLLER__CLEANUP_MS_DYNAMIC_O_AUTH_CREDENTIALS__REQUEST');
export const cleanupMsDynamicOAuthCredentialsSuccess = createAction<PayloadData<void, CleanupMsDynamicOAuthCredentials$Request>>('MS_DYNAMICS_CONTROLLER__CLEANUP_MS_DYNAMIC_O_AUTH_CREDENTIALS__SUCCESS');
export const cleanupMsDynamicOAuthCredentialsFailure = createAction<PayloadData<Error, CleanupMsDynamicOAuthCredentials$Request, true>>('MS_DYNAMICS_CONTROLLER__CLEANUP_MS_DYNAMIC_O_AUTH_CREDENTIALS__FAILURE');

export const cleanupMsDynamicOAuthCredentialsActions = [
    cleanupMsDynamicOAuthCredentialsRequest,
    cleanupMsDynamicOAuthCredentialsSuccess,
    cleanupMsDynamicOAuthCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const cleanupMsDynamicOAuthCredentials = (meta: CleanupMsDynamicOAuthCredentials$Request, config?: CleanupMsDynamicOAuthCredentials$Config) => {
    return {
        CALL_API: {
            types: cleanupMsDynamicOAuthCredentialsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/credentials`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetMsDynamicCredentials$Request {
    accountId: number;
}

export interface GetMsDynamicCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMsDynamicCredentialsRequest = createAction<PayloadData<void, GetMsDynamicCredentials$Request>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMIC_CREDENTIALS__REQUEST');
export const getMsDynamicCredentialsSuccess = createAction<PayloadData<MsDynamicCredentials, GetMsDynamicCredentials$Request>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMIC_CREDENTIALS__SUCCESS');
export const getMsDynamicCredentialsFailure = createAction<PayloadData<Error, GetMsDynamicCredentials$Request, true>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMIC_CREDENTIALS__FAILURE');

export const getMsDynamicCredentialsActions = [
    getMsDynamicCredentialsRequest,
    getMsDynamicCredentialsSuccess,
    getMsDynamicCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMsDynamicCredentials = (meta: GetMsDynamicCredentials$Request, config?: GetMsDynamicCredentials$Config) => {
    return {
        CALL_API: {
            types: getMsDynamicCredentialsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/credentials`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetMsDynamicsCredentialsOauth$Request {
    accountId: number;
    url: string;
}

export interface GetMsDynamicsCredentialsOauth$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMsDynamicsCredentialsOauthRequest = createAction<PayloadData<void, GetMsDynamicsCredentialsOauth$Request>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMICS_CREDENTIALS_OAUTH__REQUEST');
export const getMsDynamicsCredentialsOauthSuccess = createAction<PayloadData<GetAuthMsDynamicsCredentialsRequest, GetMsDynamicsCredentialsOauth$Request>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMICS_CREDENTIALS_OAUTH__SUCCESS');
export const getMsDynamicsCredentialsOauthFailure = createAction<PayloadData<Error, GetMsDynamicsCredentialsOauth$Request, true>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMICS_CREDENTIALS_OAUTH__FAILURE');

export const getMsDynamicsCredentialsOauthActions = [
    getMsDynamicsCredentialsOauthRequest,
    getMsDynamicsCredentialsOauthSuccess,
    getMsDynamicsCredentialsOauthFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} meta.url
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMsDynamicsCredentialsOauth = (meta: GetMsDynamicsCredentialsOauth$Request, config?: GetMsDynamicsCredentialsOauth$Config) => {
    const TRANSPORT_GET_PARAMS = {
        url: meta.url,
    };
    return {
        CALL_API: {
            types: getMsDynamicsCredentialsOauthActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/credentials-oauth`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetMsDynamicsCrmSettings$Request {
    accountId: number;
}

export interface GetMsDynamicsCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMsDynamicsCrmSettingsRequest = createAction<PayloadData<void, GetMsDynamicsCrmSettings$Request>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMICS_CRM_SETTINGS__REQUEST');
export const getMsDynamicsCrmSettingsSuccess = createAction<PayloadData<CrmAccountSettings, GetMsDynamicsCrmSettings$Request>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMICS_CRM_SETTINGS__SUCCESS');
export const getMsDynamicsCrmSettingsFailure = createAction<PayloadData<Error, GetMsDynamicsCrmSettings$Request, true>>('MS_DYNAMICS_CONTROLLER__GET_MS_DYNAMICS_CRM_SETTINGS__FAILURE');

export const getMsDynamicsCrmSettingsActions = [
    getMsDynamicsCrmSettingsRequest,
    getMsDynamicsCrmSettingsSuccess,
    getMsDynamicsCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMsDynamicsCrmSettings = (meta: GetMsDynamicsCrmSettings$Request, config?: GetMsDynamicsCrmSettings$Config) => {
    return {
        CALL_API: {
            types: getMsDynamicsCrmSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveAuthMsDynamicsCredentials$Request {
    accountId: number;
    saveAuthMsDynamicsCredentialsRequest?: SaveAuthMsDynamicsCredentialsRequest;
}

export interface SaveAuthMsDynamicsCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveAuthMsDynamicsCredentialsRequest = createAction<PayloadData<void, SaveAuthMsDynamicsCredentials$Request>>('MS_DYNAMICS_CONTROLLER__SAVE_AUTH_MS_DYNAMICS_CREDENTIALS__REQUEST');
export const saveAuthMsDynamicsCredentialsSuccess = createAction<PayloadData<CredentialsUpdateResult, SaveAuthMsDynamicsCredentials$Request>>('MS_DYNAMICS_CONTROLLER__SAVE_AUTH_MS_DYNAMICS_CREDENTIALS__SUCCESS');
export const saveAuthMsDynamicsCredentialsFailure = createAction<PayloadData<Error, SaveAuthMsDynamicsCredentials$Request, true>>('MS_DYNAMICS_CONTROLLER__SAVE_AUTH_MS_DYNAMICS_CREDENTIALS__FAILURE');

export const saveAuthMsDynamicsCredentialsActions = [
    saveAuthMsDynamicsCredentialsRequest,
    saveAuthMsDynamicsCredentialsSuccess,
    saveAuthMsDynamicsCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {SaveAuthMsDynamicsCredentialsRequest} [meta.saveAuthMsDynamicsCredentialsRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveAuthMsDynamicsCredentials = (meta: SaveAuthMsDynamicsCredentials$Request, config?: SaveAuthMsDynamicsCredentials$Config) => {
    return {
        CALL_API: {
            types: saveAuthMsDynamicsCredentialsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/credentials-oauth`,
            TRANSPORT_REQUEST_BODY: meta.saveAuthMsDynamicsCredentialsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveMsDynamicCredentials$Request {
    accountId: number;
    msDynamicCredentials: MsDynamicCredentials;
}

export interface SaveMsDynamicCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveMsDynamicCredentialsRequest = createAction<PayloadData<void, SaveMsDynamicCredentials$Request>>('MS_DYNAMICS_CONTROLLER__SAVE_MS_DYNAMIC_CREDENTIALS__REQUEST');
export const saveMsDynamicCredentialsSuccess = createAction<PayloadData<CredentialsUpdateResult, SaveMsDynamicCredentials$Request>>('MS_DYNAMICS_CONTROLLER__SAVE_MS_DYNAMIC_CREDENTIALS__SUCCESS');
export const saveMsDynamicCredentialsFailure = createAction<PayloadData<Error, SaveMsDynamicCredentials$Request, true>>('MS_DYNAMICS_CONTROLLER__SAVE_MS_DYNAMIC_CREDENTIALS__FAILURE');

export const saveMsDynamicCredentialsActions = [
    saveMsDynamicCredentialsRequest,
    saveMsDynamicCredentialsSuccess,
    saveMsDynamicCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {MsDynamicCredentials} meta.msDynamicCredentials
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveMsDynamicCredentials = (meta: SaveMsDynamicCredentials$Request, config?: SaveMsDynamicCredentials$Config) => {
    return {
        CALL_API: {
            types: saveMsDynamicCredentialsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/credentials`,
            TRANSPORT_REQUEST_BODY: meta.msDynamicCredentials,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveMsDynamicsCrmSettings$Request {
    accountId: number;
    crmAccountSettings?: CrmAccountSettings;
}

export interface SaveMsDynamicsCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveMsDynamicsCrmSettingsRequest = createAction<PayloadData<void, SaveMsDynamicsCrmSettings$Request>>('MS_DYNAMICS_CONTROLLER__SAVE_MS_DYNAMICS_CRM_SETTINGS__REQUEST');
export const saveMsDynamicsCrmSettingsSuccess = createAction<PayloadData<void, SaveMsDynamicsCrmSettings$Request>>('MS_DYNAMICS_CONTROLLER__SAVE_MS_DYNAMICS_CRM_SETTINGS__SUCCESS');
export const saveMsDynamicsCrmSettingsFailure = createAction<PayloadData<Error, SaveMsDynamicsCrmSettings$Request, true>>('MS_DYNAMICS_CONTROLLER__SAVE_MS_DYNAMICS_CRM_SETTINGS__FAILURE');

export const saveMsDynamicsCrmSettingsActions = [
    saveMsDynamicsCrmSettingsRequest,
    saveMsDynamicsCrmSettingsSuccess,
    saveMsDynamicsCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {CrmAccountSettings} [meta.crmAccountSettings]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveMsDynamicsCrmSettings = (meta: SaveMsDynamicsCrmSettings$Request, config?: SaveMsDynamicsCrmSettings$Config) => {
    return {
        CALL_API: {
            types: saveMsDynamicsCrmSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/settings`,
            TRANSPORT_REQUEST_BODY: meta.crmAccountSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UnlinkMsDynamicOrgId$Request {
    accountId: number;
}

export interface UnlinkMsDynamicOrgId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const unlinkMsDynamicOrgIdRequest = createAction<PayloadData<void, UnlinkMsDynamicOrgId$Request>>('MS_DYNAMICS_CONTROLLER__UNLINK_MS_DYNAMIC_ORG_ID__REQUEST');
export const unlinkMsDynamicOrgIdSuccess = createAction<PayloadData<void, UnlinkMsDynamicOrgId$Request>>('MS_DYNAMICS_CONTROLLER__UNLINK_MS_DYNAMIC_ORG_ID__SUCCESS');
export const unlinkMsDynamicOrgIdFailure = createAction<PayloadData<Error, UnlinkMsDynamicOrgId$Request, true>>('MS_DYNAMICS_CONTROLLER__UNLINK_MS_DYNAMIC_ORG_ID__FAILURE');

export const unlinkMsDynamicOrgIdActions = [
    unlinkMsDynamicOrgIdRequest,
    unlinkMsDynamicOrgIdSuccess,
    unlinkMsDynamicOrgIdFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const unlinkMsDynamicOrgId = (meta: UnlinkMsDynamicOrgId$Request, config?: UnlinkMsDynamicOrgId$Config) => {
    return {
        CALL_API: {
            types: unlinkMsDynamicOrgIdActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/crm/${meta.accountId}/ms-dynamics/org-ids`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

